import { Vector3 as t, MathUtils as i } from "three";
function u(w) {
  let D = 0, f = 1 / 0, n = [new t(), new t(), new t(), new t()];
  const y = new t(1, 0, 0), l = new t(0, 1, 0), d = new t(0, 0, 1), b = w.map((e) => new t(...e));
  for (let e = 0; e < 90; e++) {
    let o = -1 / 0, a = -1 / 0, c = 1 / 0, p = 1 / 0;
    for (let s = 0; s < w.length; s++) {
      const A = y.dot(b[s]), x = d.dot(b[s]);
      o = Math.max(A, o), a = Math.max(x, a), c = Math.min(A, c), p = Math.min(x, p);
    }
    const M = (o - c) * (a - p);
    if (M < f) {
      f = M, D = e;
      const s = new t(c, 0, p).applyAxisAngle(l, e * i.DEG2RAD), A = new t(o, 0, p).applyAxisAngle(l, e * i.DEG2RAD), x = new t(o, 0, a).applyAxisAngle(l, e * i.DEG2RAD), v = new t(c, 0, a).applyAxisAngle(l, e * i.DEG2RAD);
      n = [s, A, x, v];
    }
    y.applyAxisAngle(l, 1 * i.DEG2RAD), d.applyAxisAngle(l, 1 * i.DEG2RAD);
  }
  const g = n[0].distanceTo(n[1]), m = n[1].distanceTo(n[2]), E = { start: n[0], end: n[1], length: g }, G = { start: n[1], end: n[2], length: m }, R = { start: n[3], end: n[2], length: g }, I = { start: n[0], end: n[3], length: m };
  let r, h;
  return g > m ? (r = [E, R], h = [G, I]) : (r = [G, I], h = [E, R]), { points: n, angle: D, maxSides: r, minSides: h };
}
export {
  u as smallestBBox
};
//# sourceMappingURL=index.js.map
